import { createSvgIcon } from "@mui/material";

const Logo = createSvgIcon(
    <svg viewBox="0 0 300 300" aria-label="Verifique">
        <circle cx="150" cy="150" r="75" fill="none" stroke="#e032e6" strokeWidth="7" opacity="0.22"></circle>
        <circle cx="150" cy="150" r="57" fill="none" stroke="#e032e6" strokeWidth="7" opacity="0.38"></circle>
        <circle cx="150" cy="150" r="39" fill="none" stroke="#e032e6" strokeWidth="7" opacity="0.55"></circle>
        <circle cx="150" cy="150" r="21" fill="none" stroke="#e032e6" strokeWidth="7" opacity="0.72"></circle>
        <line x1="97.5" y1="75" x2="150" y2="225" stroke="#5a53a3" strokeWidth="9" strokeLinecap="round"></line>
        <line x1="202.5" y1="75" x2="150" y2="225" stroke="#5a53a3" strokeWidth="9" strokeLinecap="round"></line>
        <path d="M 138 142 L 150 159 L 171 133" stroke="#c41fc9" strokeWidth="9" fill="none" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>,
    'Logo',
);

export default Logo;
